import Training from '../../training';

/**
 * Create the action
 */

const { thunk, request, success, error } = Training.destroy(({ trainingId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };